<template>
    <div class="row justify-content-center">
        <div class="col-md-12">
            <Loading v-if="showLoading" />
            <div class="card mb-3 py-3 px-3">
                <div class="row">
                    <div class="col-md-3">
                        <form v-on:submit.prevent="searchTerminal">
                            <label for="national-code">شماره پایانه</label>
                            <div class="input-group">
                                <input class="form-control text-left" maxlength="8" id="national-code" type="tel" v-model="terminalNo">
                                <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-12 mt-4" v-if="Object.keys(terminalInfo).length">
                        <table class="table table-hover table-bordered">
                            <tbody>
                                <tr>
                                    <td style="width: 20%;">نام :</td>
                                    <td>{{ terminalInfo.name }}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%;">سازمان :</td>
                                    <td>{{ terminalInfo.merchantName }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-12" v-if="Object.keys(terminalInfo).length">
                        <form class="row mt-2" v-on:submit.prevent="searchPan">
                            <div class="col-3 form-group">
                                <label>
                                    <label style="color: red; height: 2px;" >*</label>
                                    شماره همراه</label>
                                <input required type="tel" class="form-control" v-model="phone" v-mask="'09##-#######'">
                            </div>
                             <div class="col-3 form-group ">
                            <label for="national-code">شماره کارت</label>
                            <div class="input-group">
                                <input class="form-control text-left" v-mask="'####-####-####-####'" id="pan" type="tel" v-model="pan">
                                <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                            </div>
                               </div>
                        </form>
                    </div>
                    <div class="col-md-12 mt-4" v-if="Object.keys(panInfo).length">
                        <table class="table table-hover table-bordered">
                            <tbody>
                                <tr>
                                    <td style="width: 20%;">نام :</td>
                                    <td>{{ panInfo.name }}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%;">نام خانوادگی :</td>
                                    <td>{{ panInfo.family }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-12" v-if="Object.keys(terminalInfo).length && Object.keys(panInfo).length">
                        <button class="btn btn-success" @click="assignPanToTerminal">تخصیص کارت به پایانه</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'create',
    data(){
        return {
            showLoading: false,
            terminalNo: '',
            terminalInfo: {},
            pan: '',
            phone: '',
            panInfo: {}
        }
    },
    methods: {
        searchTerminal(){
            this.showLoading = true;
            this.terminalInfo = {};
            this.panInfo = {};
            this.pan = '';
            this.$api.get(`MosqueOrganization/ReturnTerminalInfo?TerminalNumber=${this.terminalNo}`).then(({ data }) => {
                if(data.status){
                    this.terminalInfo = {
                        name: data.result.last_name,
                        merchantName: data.result.merchant_name
                    };
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        searchPan(){
            this.showLoading = true;
            this.panInfo = {};
            this.$api.post('MosqueOrganization/CheckCardValidation',{cardNumber: this.pan.replace(/-/g,'')}).then(({ data }) => {
                if(data.status){
                    this.panInfo = {
                        name: data.result.name,
                        family: data.result.family
                    };
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        assignPanToTerminal(){
            this.showLoading = true;
            const postedData = {
                terminalNumber: parseInt(this.terminalNo),
                terminalCards: [
                    {
                        card: this.pan.replace(/-/g,''),
                        percent: 100,
                        phoneNumber: this.phone.replace('-', '') 
                    }
                ]
            }
            this.$api.post('MosqueOrganization/AddCards',postedData).then(({ data }) => {
                if(data.status && !data.result.errors.length){
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'تخصیص با موفقیت انجام شد',
                    }).then(res => {
                        if(res.isConfirmed){
                            this.$router.push({name: 'mosque.index'});
                        }
                    });
                }else{
                    let html = '';
                    data.result.errors.map(err => html += err + '<br>');
                    this.$swal({
                        icon: 'error',
                        title: 'خطا !',
                        html
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            })
        }
    }
}
</script>